module.exports = __webpack_public_path__ + "img/romance.6c590738.svg";